import {IProfileItemModel, ProfileItemModel} from './profile-item.model';

export interface IFaehigkeit extends IProfileItemModel {
  id?: string;
  kategorie?: string;
  kategorieEn?: string;
  faehigkeit?: string;
  faehigkeitEn?: string;
  level?: string;
  key?: string;
  inKatalogAufgenommen?: boolean;
  isVorgehensmodell?: boolean;
  isTechnologie?: boolean;
  isProgrammiersprache?: boolean;
  isWerkzeug?: boolean;
  wikipage?: string;
}

export class Faehigkeit extends ProfileItemModel implements IFaehigkeit {
  kategorieEn?: string;
  faehigkeitEn?: string;

  constructor(
    public id?: string,
    public kategorie?: string,
    public faehigkeit?: string,
    public level?: string,
    public key?: string,
    public inKatalogAufgenommen?: boolean,
    public isVorgehensmodell?: boolean,
    public isTechnologie?: boolean,
    public isProgrammiersprache?: boolean,
    public isWerkzeug?: boolean,
    public wikipage?: string
  ) {
    super();
    this.id = id ? id : undefined;
    this.kategorie = kategorie ? kategorie : undefined;
    this.faehigkeit = faehigkeit ? faehigkeit : undefined;
    this.level = level ? level : undefined;
    this.key = this.kategorie + '.' + this.faehigkeit;
    this.inKatalogAufgenommen = inKatalogAufgenommen ? inKatalogAufgenommen : false;
    this.isVorgehensmodell = isVorgehensmodell ? isVorgehensmodell : false;
    this.isTechnologie = isTechnologie ? isTechnologie : false;
    this.isProgrammiersprache = isProgrammiersprache ? isProgrammiersprache : false;
    this.isWerkzeug = isWerkzeug ? isWerkzeug : false;
    this.wikipage = wikipage ? wikipage : undefined;
  }

  static emptyObject(): Faehigkeit {
    const s = new Faehigkeit();
    s.id = '0';
    s.kategorie = '';
    s.faehigkeit = '';
    s.level = '';
    s.key = '';
    s.inKatalogAufgenommen = false;
    s.isVorgehensmodell = false;
    s.isTechnologie = false;
    s.isProgrammiersprache = false;
    s.isWerkzeug = false;
    s.wikipage = '';
    return s;
  }

  static fromJson(json: IFaehigkeit) {
    const faehigkeit = new Faehigkeit();
    faehigkeit.id = json.id;
    faehigkeit.kategorie = json.kategorie;
    faehigkeit.kategorieEn = json.kategorieEn;
    faehigkeit.faehigkeit = json.faehigkeit;
    faehigkeit.faehigkeitEn = json.faehigkeitEn;
    faehigkeit.level = json.level;
    faehigkeit.key = json.kategorie + '.' + json.faehigkeit;
    faehigkeit.inKatalogAufgenommen = json.inKatalogAufgenommen;
    faehigkeit.isVorgehensmodell = json.isVorgehensmodell;
    faehigkeit.isTechnologie = json.isTechnologie;
    faehigkeit.isProgrammiersprache = json.isProgrammiersprache;
    faehigkeit.isWerkzeug = json.isWerkzeug;
    faehigkeit.wikipage = json.wikipage;
    return faehigkeit;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Faehigkeit() as T;
  }
}
